import { translate } from '../../../../../common/i18n';

Blockly.Blocks.go_back_to_real = {
    init: function init() {
        this.appendDummyInput().appendField(translate('Go Back To Real Trades'));
        this.setColour('#f2f2f2');
        this.setPreviousStatement(true, null);
        this.setNextStatement(true, null);
        this.setTooltip(
            translate(
                'It will tell the system to use the connected real account in the next trade. This block will work only if it\'s coming from a virtual trade'
            )
        );
    },
    onchange: function onchange() {},
};

Blockly.JavaScript.go_back_to_real = () => 'BinaryBotPrivateVirtualSettings.changeToReal = true;';



// WEBPACK FOOTER //
// ./src/botPage/view/blockly/blocks/virtualtrades/gobacktoreal.js